module.exports = __webpack_public_path__ + "img/sequence-kyoto-gojo@2x.a2341fcd.jpg";